import React from 'react';
import FontAwesomeSpriteIcon, {
  FontAwesomeSpriteIconProps,
} from '../FontAwesomeLocal/FontAwesomeSpriteIcon';
import theme from 'src/config/theme';
import { EmptyContentWrapper, StyledEmptyMessage } from './styled';

type Props = {
  message?: string;
  icon?: FontAwesomeSpriteIconProps['icon'];
};

const EmptyContent: React.FC<Props> = ({ message, icon }) => {
  const label = message || 'Deze handleiding is (nog) niet beschikbaar.';
  return (
    <EmptyContentWrapper id="empty-container">
      {icon && <FontAwesomeSpriteIcon icon={icon} iconSize="3x" color={theme.palette.grey[900]} />}
      <StyledEmptyMessage>{label}</StyledEmptyMessage>
    </EmptyContentWrapper>
  );
};

export default EmptyContent;
